import { Spinner } from '@legalshield/adonis-ux-framework';
import React from 'react';

const Loading: React.FC = () => {
  return <Spinner blocking spinnerSize="xlarge" color="brand" />;
};

export default Loading;
